/**
 * The store / enqueue seam — ENGINEERING §3.
 *
 * The engine does not know about Firestore, and **no image model is ever called from the
 * engine**. `resolve` reads and writes through `ResolveStore`, and hands a `pending` record
 * to `enqueue`; the Firestore-triggered functions do the paid work behind that callback.
 */
/**
 * The default clock: a `TimestampLike` from the host's wall clock. Production passes
 * Firestore's server timestamp instead — the engine never assumes one.
 */
export function systemNow() {
    const millis = Date.now();
    return {
        seconds: Math.floor(millis / 1000),
        nanoseconds: (millis % 1000) * 1_000_000,
        toMillis: () => millis,
    };
}
//# sourceMappingURL=store.js.map